import React, {useState, useContext, useEffect} from 'react';
import SelectComponent from '../../Selects/SelectFilter';
import {useTranslation} from 'react-i18next';
import {Context} from '../../../Helpers/Auth';
import {DragDropContext, Droppable, Draggable} from 'react-beautiful-dnd';
import Spinner from '../../../components/Spinner';
import Colunas from './Colunas';
import {KanbanContext, KanbanProvider} from './Context/index';
import {moverCard} from './Api';
import LoadingModal from '../../LoadingModal';
import NotFound from '../../NotFound';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Pipeline({
    consulta,
    setConsulta,
    kanban,
    setKanban,
    filtroEstado,
    filtroRep,
    filtroPotencial,
    filtroMarca,
    filtroNome,
    filtroEtapa,
    filtroFamilia,
    filtroEmpresa,
    filtroDt,
    filtroValor,
    setFiltroStatusDt,
    filtroStatusDt,
    setFiltroDt,
    setFiltroFamilia,
    setFiltroEtapa,
    setFiltroNome,
    setFiltroValor,
    setEditarNegocio,
    filtroCodigo,
    setFiltroCodigo,
    onRowClick,

    setOpenTab,

    filtroCategoria,
    filtroNacionalInternacional,
}) {
    const {t} = useTranslation();
    const {acessos, rep, utilizador, nome} = useContext(Context);
    const [semDadosEstado, setSemDadosEstado] = useState(false);
    const [loading, setLoading] = useState(false);
    const [semDados, setSemDados] = useState(false);

    const {move, GetData, etapas, negocios} = useContext(KanbanContext);

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    }else if (idiomaAtual == 'es') {
        lang = 'ES'; 
    }

  
    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;
        debugger;
        GetData(
            lang,
            signal,
            kanban,
            consulta,
            filtroEstado,
            filtroRep,
            filtroPotencial,
            filtroNome,
            filtroEtapa,
            filtroEmpresa,
            filtroDt,
            filtroValor,
            filtroCodigo,
            filtroCategoria,
            filtroMarca,
            filtroNacionalInternacional,
            filtroFamilia,
        );
        return () => {
            controller.abort();
        };
    }, [
        kanban,
        consulta,
        filtroEstado,
        filtroRep,
        filtroPotencial,
        filtroNome,
        filtroEtapa,
        filtroEmpresa,
        filtroDt,
        filtroValor,
        filtroCodigo,
        filtroCategoria,
        filtroMarca,
        filtroNacionalInternacional,
        filtroFamilia,
    ]);

    const handleToggleChange = () => {
        setConsulta(!consulta);
    };

    useEffect(() => {
        if (etapas.length == 0 && negocios.length == 0) {
         setLoading(true);
            
        } else if (etapas.length != 0 && negocios.length == 0){
            setLoading(false);
            setSemDados(true)
        }else {
            setLoading(false);
            setSemDados(false)
        }
    }, [etapas]);
   

    async function handleDragEnd(result) {
        const {draggableId} = result;
        const {source, destination} = result;
        if (!destination) {
            return;
        }

        if (source.droppableId === destination.droppableId) {
            // const items = reorder(
            //     getList(source.droppableId),
            //     source.index,
            //     destination.index
            // );
        } else {
            try {
                const res = await moverCard(draggableId, destination.droppableId, lang);
                debugger
                if (res.data.success) {
                    move(draggableId, source, destination);
                    // filtrarTags()
                } else {
                    const errorMessage = res.data.error_object?.errorMessages?.[0] || 'Ocorreu um erro.';
                    toast.error(errorMessage);
                }
            } catch (error) {
                toast.error('Erro ao mover o card.');
            }
        }
    }

    return (
        <div>
            <label className="relative inline-flex items-center cursor-pointer">
                <input type="checkbox" checked={consulta} onChange={handleToggleChange} className="sr-only peer" />
                <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-800 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">{consulta ? t('consulta') : t('naoConsulta')}</span>
            </label>
            {loading && (
                <div className="flex flex-row mt-14 justify-center">
                    <>
                        <Spinner />
                    </>
                </div>
            )}
            {!loading && (
                <div className="flex flex-row w-full mt-2">
                    <DragDropContext onDragEnd={handleDragEnd}>
                        <div className="flex justify-start h-full w-full ">
                            {etapas.map(etapa => {
                                return (
                                    <Colunas
                                        loading={loading}
                                        setLoading={setLoading}
                                        setOpenTab={setOpenTab}
                                        onRowClick={onRowClick}
                                        setEditarNegocio={setEditarNegocio}
                                        negocios={negocios}
                                        etapa={etapa}
                                    />
                                );
                            })}
                        </div>
                    </DragDropContext>
                </div>
            )}
            {semDados && !loading && <NotFound frase={t('semRegistos')} />}
        </div>
    );
}

export default Pipeline;
